import { Check } from "lucide-react";
import { chip } from "../OrderSpecFields";

export const tradeInput = "w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white placeholder:text-zinc-500 outline-none transition-colors focus:border-white/40";

const slug = (s) => String(s).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const Question = ({ n, label, hint, children, testid }) => (
  <div id={testid} data-testid={testid} className="scroll-mt-28 rounded-[22px] border border-white/10 bg-white/[0.03] p-4 sm:p-5">
    <p className="flex items-baseline gap-2.5 text-sm font-semibold text-white">
      {n && <span className="font-display text-xs text-zinc-400">{String(n).padStart(2, "0")}</span>}
      {label}
    </p>
    {hint && <p className="mt-1 text-xs text-zinc-400">{hint}</p>}
    <div className="mt-3">{children}</div>
  </div>
);

export const Choices = ({ options, value, onChange, testid }) => (
  <div className="flex flex-wrap gap-2">
    {options.map(([id, label]) => (
      <button type="button" key={String(id)} data-testid={`${testid}-${slug(id)}`} aria-pressed={value === id} onClick={() => onChange(id)} className={chip(value === id)}>{label}</button>
    ))}
  </div>
);

// Quadradinho de marcar com título e explicação.
export const CheckBox = ({ on, onChange, title, hint, testid }) => (
  <button type="button" role="checkbox" aria-checked={on} data-testid={testid} onClick={() => onChange(!on)}
    className={`flex w-full items-start gap-3 rounded-2xl border p-3 text-left transition-colors ${on ? "border-amber-400/70 bg-amber-400/10" : "border-white/10 hover:border-white/25"}`}>
    <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md border transition-colors ${on ? "border-amber-400 bg-amber-400 text-black" : "border-zinc-500"}`}>
      {on && <Check className="h-3.5 w-3.5" strokeWidth={3} />}
    </span>
    <span>
      <span className="block text-sm font-medium text-zinc-100">{title}</span>
      {hint && <span className="mt-0.5 block text-xs text-zinc-400">{hint}</span>}
    </span>
  </button>
);

export const YesNo = ({ value, onChange, testid }) => (
  <Choices options={[[true, "Sim"], [false, "Não"]]} value={value} onChange={onChange} testid={testid} />
);
